import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";
import { ContractorLoadingReason } from "../context";

interface ContractorLoaderProps {
  reason: ContractorLoadingReason;
}

export const ContractorLoader = ({ reason }: ContractorLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center h-64 space-y-4">
      <Spinner />
      <p className="text-sm text-muted-foreground">
        {t("contractors.loadingStates." + reason)}
      </p>
    </div>
  );
};
